import Modal from "./Modal";
import Ajax from "base/Ajax";
import moment from "moment";
import SelectHandler from "./SelectHandler";
import FormValidator from "base/FormValidator";
import Message from "base/Message";
import simplebar from "simplebar";

const MAX_TICKETS = 30;

class LocationModal {

    static show_modal(id, color, name) {
        let modal = new Modal({
            "title": name,
            "color": color,
            "destroyOnClose": true
        });

        let validator;

        let $content = (
            eotwJSXFactory('div', {class: "modal__loading"})
        );

        modal.location_id = id;

        modal.setContent($content);
        modal.show();

        Ajax.get("sk8house", "locations/" + id, {}, Ajax.WEBSITE).then((data) => {
            data["color"] = color;
            LocationModal.create_modal_content(modal, data, validator);
        }).catch(e => {
            modal.hide();
            alert(e);
        });
    }

    static create_side_booking_content(data) {
        let $select = (
            eotwJSXFactory('select', {class: "form__input form__input--select js-select", id: "date"}, [
                data.futureEvents.map((event) => (
                    eotwJSXFactory('option', {value: event.id}, [moment.unix(event.eventDate.timestamp).format('Do MMMM YYYY')])
                ))
            ])
        );

        new SelectHandler($select);

        return (
            eotwJSXFactory('div', {class: "modal__booking"}, [
                eotwJSXFactory('h4', null, ["Book Online"]),
                eotwJSXFactory('form', {class: "form js-modal-date-form"}, [
                    eotwJSXFactory('div', {class: "form__row form__row--one-third select-dummy"}, [
                        eotwJSXFactory('label', {class: "form__label form__label--modal", for: "date"}, ["Select your date"]),
                        eotwJSXFactory('div', {class: "select-dummy__container select-dummy__container--home"}, [
                            eotwJSXFactory('span', {class: "select-dummy__text select-dummy__text--home js-select-placeholder", 'data-id': "date"}, [moment.unix(data.futureEvents[0].eventDate.timestamp).format('Do MMMM YYYY')]),
                            $select,
                            eotwJSXFactory('span', {class: "select-dummy__arrow"}).html('<svg><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="' + window.CONFIG.urls.website + '/includes/svg-icons.svg#down-arrow"/></svg>')
                        ])
                    ]),
                    eotwJSXFactory('div', {class: "form__row form__row--submit"}, [
                        eotwJSXFactory('button', {class: "form__submit form__submit--paypal"}, ["Book Online Now"])
                    ])
                ])
            ])
        );
    }

    static create_modal_content(modal, data, validator) {
        if (validator) validator.destroy();
        let hasBooking = data.futureEvents.length > 0;
        let color = data['color'];

        let regular_title = "Regular Dates";
        let additional_title = "Extra School Holiday Dates";

        //Stratford Upon Avon location
        // if(modal.location_id === "09"){
        //     regular_title = "Family & Toddlers session";
        //     additional_title = "Secondary & Upwards";
        // }

        let $bookingContent = hasBooking != true ? '' : LocationModal.create_side_booking_content(data);
        let alternativePrice = data.prices.adultSkatePrice === 0 ? '' : '£' + data.prices.adultPrice + ' if you have your own skates';
        let $partiesStar = !data.parties ? '' : eotwJSXFactory('div', {class: "modal__date"}, ["Parties Available"]);
        let $addressLink = data.addressLink === null || data.addressLink === '' ? '' : eotwJSXFactory('a', {href: data.addressLink, target: "_blank"}, ["Get directions"]);
        let mainPrice = parseFloat(data.prices.adultPrice) + parseFloat(data.prices.adultSkatePrice);

        let $childSkates = parseFloat(data.prices.childSkatePrice) === 0.00 ? '' : ' £' + parseFloat(data.prices.childPrice).toFixed(2) + ' if you have your own skates';

        let $childPrice = parseFloat(data.prices.adultPrice) + parseFloat(data.prices.adultSkatePrice) !== parseFloat(data.prices.childPrice) + parseFloat(data.prices.childSkatePrice) ? eotwJSXFactory('div', {class: "modal__about"}, [eotwJSXFactory('h5', null, ["Child Prices"]),eotwJSXFactory('p', null, [eotwJSXFactory('strong', null, ["£", (parseFloat(data.prices.childPrice) + parseFloat(data.prices.childSkatePrice)).toFixed(2), " including skate hire"]),$childSkates])]) : '';

        let $extraAllYear = (data.allYearDates2 === null || data.allYearDates2 === '' || data.allYearTimes2 === null || data.allYearTimes2 === '') ? '' : (
            eotwJSXFactory('div', {class: "modal__details"}, [
                eotwJSXFactory('p', {class: "modal__icon-text"}, [
                    eotwJSXFactory('span', {class: "modal__icon"}).html('<svg><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="' + window.CONFIG.urls.website + '/includes/svg-icons.svg#calendar-icon"/></svg>'),
                    "Every ", data.allYearDates2
                ]),
                eotwJSXFactory('p', {class: "modal__icon-text"}, [
                    eotwJSXFactory('span', {class: "modal__icon"}).html('<svg><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="' + window.CONFIG.urls.website + '/includes/svg-icons.svg#clock-icon"/></svg>'),
                    data.allYearTimes2
                ])
            ])
        );


        let $allYear = (data.allYearDates === null || data.allYearDates === '' || data.allYearTimes === null || data.allYearTimes === '') ? '' : (
            eotwJSXFactory('div', null, [
                eotwJSXFactory('h6', null, [regular_title]),
                eotwJSXFactory('div', {class: "modal__details"}, [
                    eotwJSXFactory('p', {class: "modal__icon-text"}, [
                        eotwJSXFactory('span', {class: "modal__icon"}).html('<svg><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="' + window.CONFIG.urls.website + '/includes/svg-icons.svg#calendar-icon"/></svg>'),
                        "Every ", data.allYearDates
                    ]),
                    eotwJSXFactory('p', {class: "modal__icon-text"}, [
                        eotwJSXFactory('span', {class: "modal__icon"}).html('<svg><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="' + window.CONFIG.urls.website + '/includes/svg-icons.svg#clock-icon"/></svg>'),
                        data.allYearTimes
                    ])
                ]),
                $extraAllYear
            ])
        );

        let $extraSchoolDates = (data.extraDates === null || data.extraDates === '' || data.extraTimes === null || data.extraTimes === '') ? '' : (
            eotwJSXFactory('div', null, [
                eotwJSXFactory('h6', null, [additional_title]),
                eotwJSXFactory('div', {class: "modal__details"}, [
                    eotwJSXFactory('p', {class: "modal__icon-text"}, [
                        eotwJSXFactory('span', {class: "modal__icon"}).html('<svg><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="' + window.CONFIG.urls.website + '/includes/svg-icons.svg#calendar-icon"/></svg>'),
                        "Every ", data.extraDates
                    ]),
                    eotwJSXFactory('p', {class: "modal__icon-text"}, [
                        eotwJSXFactory('span', {class: "modal__icon"}).html('<svg><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="' + window.CONFIG.urls.website + '/includes/svg-icons.svg#clock-icon"/></svg>'),
                        data.extraTimes
                    ])
                ])
            ])
        );

        let $newContent = (
            eotwJSXFactory('div', {class: hasBooking == true ? "modal__main-content modal__main-content--booking" : "modal__main-content"}, [
                eotwJSXFactory('div', {class: "modal__flex"}, [
                    $partiesStar,
                    eotwJSXFactory('div', {class: "modal__column modal__column--first"}, [
                        eotwJSXFactory('div', {class: "modal__address"}, [
                            eotwJSXFactory('span', {class: "modal__address-icon"}).html('<svg><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="' + window.CONFIG.urls.website + '/includes/svg-icons.svg#address-icon"/></svg>'),
                            eotwJSXFactory('p', null, [data.addressFull]),
                            $addressLink
                        ]),
                        eotwJSXFactory('div', {class: "modal__price"}, [
                            eotwJSXFactory('span', {class: "modal__price-icon"}).html('<svg><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="' + window.CONFIG.urls.website + '/includes/svg-icons.svg#price-icon"/></svg>'),
                            eotwJSXFactory('p', null, [eotwJSXFactory('strong', null, ["£", mainPrice.toFixed(2), " including skate hire"]),alternativePrice]),
                            $childPrice,
                            eotwJSXFactory('p', null, ["PLEASE NOTE: Payment on arrival is cash only. No booking required."])
                        ])
                    ]),
                    eotwJSXFactory('div', {class: "modal__column"}, [
                        eotwJSXFactory('div', {class: "modal__about"}, [
                            eotwJSXFactory('h5', null, ["About this event"]),
                            eotwJSXFactory('p', null, [data.about]),
                            $allYear,
                            $extraSchoolDates
                        ])
                    ])
                ]),
                $bookingContent
            ])
        );

        modal.setContent($newContent);

        if (hasBooking) {
            validator = FormValidator.attach($bookingContent.find('.js-modal-date-form')).on("submit", function ($form) {
                let dateId = $form.find('.js-select').val();
                data["color"] = color;
                LocationModal.create_modal_booking_form(modal, data, validator, $form.find('.js-select').val())
            });

        }

        modal.on('destroy', () => {
            if (validator) validator.destroy();
        });
    }

    static update_price($bookingForm, tickets) {
        let price = 0.00;

        Object.keys(tickets).map((ticketType) => {
            tickets[ticketType].map((ticket) => {
                price += window.eventData[ticketType].price;
                if (ticket.size !== null && ticket.size !== '') {
                    price += window.eventData[ticketType].skateHire;
                }
            });
        });

        $bookingForm.find('.js-show-price').text(price.toFixed(2));

        if (price === 0.00) {
            $bookingForm.find('.form__submit').addClass('form__submit--disabled');
        } else if (tickets.adult.length + tickets.child.length <= window.eventData.spacesRemaining && tickets.adult.length + tickets.child.length <= MAX_TICKETS && (tickets.adult.length > 0 || tickets.child.length > 0)) {
            $bookingForm.find('.form__submit').removeClass('form__submit--disabled');
        }

    }

    static update_tickets($bookingForm, tickets) {
        let $elm;
        try {
            $elm = $($bookingForm.find('.js-skate-sizes')[0].SimpleBar.getContentElement()).html('');
        } catch (e) {
            $elm = $('.js-skate-sizes').html('');
        }

        Object.keys(tickets).map((ticketType) => {
            let i = 1;
            tickets[ticketType].map((ticket) => {

                let selectText = 'Not Required';

                let $select = (
                    eotwJSXFactory('select', {class: "form__input form__input--select js-select", 'data-type': ticketType, 'data-index': i, name: 'tickets[' + ticketType + '][' + i + ' ]', id: 'tickets[' + ticketType + '][' + i + ' ]'}, [
                        eotwJSXFactory('option', {value: ""}, ["Not Required"]),
                        window.skateSizes[ticketType].map((size) => {
                            if (ticket.size === size.id) {
                                selectText = size.name;
                                return (eotwJSXFactory('option', {selected: true, value: size.id}, [size.name]));
                            } else {
                                return (eotwJSXFactory('option', {value: size.id}, [size.name]));
                            }
                        })
                    ])
                );

                new SelectHandler($select);

                $select.on('change', function () {
                    tickets[$(this).attr('data-type')][parseInt($(this).attr('data-index')) - 1].size = $(this).val();
                    LocationModal.update_price($bookingForm, tickets);
                });

                let $skateSizeRow = (
                    eotwJSXFactory('div', {class: "form__row form__row--flex select-dummy"}, [
                        eotwJSXFactory('label', {class: "form__label form__label--small", for: 'tickets[' + ticketType + '][' + i + ' ]'}, [(ticketType.charAt(0).toUpperCase() + ticketType.slice(1)) + ' ' + i]),
                        eotwJSXFactory('div', {class: "select-dummy__container"}, [
                            eotwJSXFactory('span', {class: "select-dummy__text js-select-placeholder"}, [selectText]),
                            $select,
                            eotwJSXFactory('span', {class: "select-dummy__arrow"}).html('<svg><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="' + window.CONFIG.urls.website + '/includes/svg-icons.svg#down-arrow"/></svg>')
                        ])
                    ])
                );
                $elm.append($skateSizeRow);
                i++;
            });
        });

        LocationModal.update_price($bookingForm, tickets);
    }

    static getSkateSizes() {
        if (typeof window.skateSizes !== 'undefined' && (window.skateSizes.adult.length > 0 || window.skateSizes.child.length > 0)) return;
        window.skateSizes = [];
        window.skateSizes.adult = [];
        window.skateSizes.child = [];

        Ajax.get('sk8house', 'skate-sizes', {}, Ajax.WEBSITE).then((data) => {
            data.map((size) => {
                window.skateSizes[size.skateType.toLowerCase()].push({id: size.id, name: size.name});
            });
        }).catch((e) => {
            new Message(e, 'Could not retrieve a list of available skate sizes');
        });
    }

    static check_tickets($bookingForm, tickets) {
        if (tickets.adult.length + tickets.child.length > MAX_TICKETS) {
            $bookingForm.find('.js-ticket-error').text('You can only order up to a maximum of 30 tickets online, if you require more tickets please give us a call').addClass('form__error-message--shown');
            $bookingForm.find('.form__submit').addClass('form__submit--disabled');
        } else if (tickets.adult.length + tickets.child.length > window.eventData.spacesRemaining) {
            $bookingForm.find('.js-ticket-error').text('There are not enough spaces left to complete your booking').addClass('form__error-message--shown');
            $bookingForm.find('.form__submit').addClass('form__submit--disabled');
        } else if (tickets.adult.length > 0 || tickets.child.length > 0) {
            $bookingForm.find('.js-ticket-error').text('').removeClass('form__error-message--shown');
            $bookingForm.find('.form__submit').removeClass('form__submit--disabled');
        }
    }

    static create_modal_booking_form(modal, data, validator, date) {

        if (validator) validator.destroy();

        window.eventData = data.futureEvents.filter((e) => {
            return e.id === date;
        })[0];

        window.eventData.adult = {
            price: parseFloat(data.prices.adultPrice),
            skateHire: parseFloat(data.prices.adultSkatePrice)
        };

        window.eventData.child = {
            price: parseFloat(data.prices.childPrice),
            skateHire: parseFloat(data.prices.childSkatePrice)
        };

        let tickets = {
            child: [],
            adult: []
        };

        LocationModal.getSkateSizes();


        let totalPrice = 0.00;
        let totalSpaces;

        let $select = (
            eotwJSXFactory('select', {class: "form__input form__input--select js-select", id: "date"}, [
                data.futureEvents.map((event) => (
                    eotwJSXFactory('option', {value: event.id}, [moment.unix(event.eventDate.timestamp).format('Do MMMM YYYY')])
                ))
            ])
        );

        new SelectHandler($select);

        $select.on('change', function () {
            let date = $(this).val();
            window.eventData = data.futureEvents.filter((e) => {
                return e.id === date;
            })[0];
            LocationModal.check_tickets($bookingForm, tickets);
            LocationModal.update_price($bookingForm, tickets);
        });


        let $skate_sizes = (eotwJSXFactory('div', {class: "modal__skates-sizes js-skate-sizes"}));

        try {
            new simplebar($skate_sizes[0]);
        } catch (e) {
            $skate_sizes.addClass('modal__skates-sizes--browser-scroll')
        }

        let $bookingForm = (
            eotwJSXFactory('form', {class: "modal__booking-form"}, [
                eotwJSXFactory('button', {type: "button", class: "modal__back js-back-modal"}, ["Back"]),
                eotwJSXFactory('div', {class: "modal__booking-flex"}, [
                    eotwJSXFactory('div', {class: "modal__booking-column modal__booking-column--first"}, [
                        eotwJSXFactory('div', {class: "form__row select-dummy"}, [
                            eotwJSXFactory('label', {class: "form__label form__label--modal", for: "date"}, ["Select your date"]),
                            eotwJSXFactory('div', {class: "select-dummy__container"}, [
                                eotwJSXFactory('span', {class: "select-dummy__text js-select-placeholder", 'data-id': "date"}, [moment.unix(window.eventData.eventDate.timestamp).format('Do MMMM YYYY')]),
                                $select,
                                eotwJSXFactory('span', {class: "select-dummy__arrow"}).html('<svg><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="' + window.CONFIG.urls.website + '/includes/svg-icons.svg#down-arrow"/></svg>')
                            ])
                        ]),
                        eotwJSXFactory('div', {class: "form__row"}, [
                            eotwJSXFactory('span', {class: "form__label form__label--modal"}, ["Tickets Required"]),
                            eotwJSXFactory('div', {class: "form__row form__row--flex-large"}, [
                                eotwJSXFactory('label', {class: "form__label form__label--small", for: "children"}, ["No. of Children"]),
                                eotwJSXFactory('div', {class: "form__numeric-holder"}, [
                                    eotwJSXFactory('button', {type: "button", class: "form__numeric js-numeric-button", 'data-direction': "-", 'data-type': "child"}),
                                    eotwJSXFactory('input', {class: "form__input form__input--numeric number js-ticket-amount", type: "number", name: "child", id: "child", 'data-type': "child", value: tickets.child.length}),
                                    eotwJSXFactory('button', {type: "button", class: "form__numeric form__numeric--plus js-numeric-button", 'data-direction': "+", 'data-type': "child"})
                                ])
                            ]),
                            eotwJSXFactory('div', {class: "form__row form__row--flex-large"}, [
                                eotwJSXFactory('label', {class: "form__label form__label--small", for: "adults"}, ["No. of Adults"]),
                                eotwJSXFactory('div', {class: "form__numeric-holder"}, [
                                    eotwJSXFactory('button', {type: "button", class: "form__numeric js-numeric-button", 'data-direction': "-", 'data-type': "adult"}),
                                    eotwJSXFactory('input', {class: "form__input form__input--numeric number js-ticket-amount", type: "number", name: "adult", id: "adult", 'data-type': "adult", value: tickets.adult.length}),
                                    eotwJSXFactory('button', {type: "button", class: "form__numeric form__numeric--plus js-numeric-button", 'data-direction': "+", 'data-type': "adult"})
                                ])
                            ]),
                            eotwJSXFactory('span', {class: "form__error-message js-ticket-error"})
                        ])
                    ]),
                    eotwJSXFactory('div', {class: "modal__booking-column modal__booking-column--skates"}, [
                        eotwJSXFactory('div', {class: "modal__skates-require"}, [
                            eotwJSXFactory('span', {class: "form__label form__label--modal"}, ["Skate Sizes Required"]),
                            $skate_sizes
                        ])
                    ]),
                    eotwJSXFactory('div', {class: "modal__booking-column modal__booking-column--last"}, [
                        eotwJSXFactory('div', {class: "modal__left"}, [
                            eotwJSXFactory('div', {class: "form__row"}, [
                                eotwJSXFactory('label', {class: "form__label form__label--modal", for: "name"}, ["Name"]),
                                eotwJSXFactory('span', {class: "form__input-wrap"}, [
                                    eotwJSXFactory('input', {type: "text", id: "name", name: "name", class: "form__input form__input--text"}),
                                    eotwJSXFactory('span', {class: "form__error-message"}, ["Please enter your name"])
                                ])
                            ]),
                            eotwJSXFactory('div', {class: "form__row"}, [
                                eotwJSXFactory('label', {class: "form__label form__label--modal", for: "email"}, ["Email Address"]),
                                eotwJSXFactory('span', {class: "form__input-wrap"}, [
                                    eotwJSXFactory('input', {type: "email", id: "email", name: "email", class: "form__input form__input--text"}),
                                    eotwJSXFactory('span', {class: "form__error-message"}, ["Please enter a valid email address"])
                                ])
                            ])
                        ]),
                        eotwJSXFactory('div', {class: "modal__right"}, [
                            eotwJSXFactory('div', {classs: "form__row"}, [
                                eotwJSXFactory('span', {class: "modal__price-text"}, ["Price: ", eotwJSXFactory('strong', null, ["£",
                                    eotwJSXFactory('span', {class: "js-show-price"}, [totalPrice.toFixed(2)])
                                ])])
                            ]),
                            eotwJSXFactory('div', {class: "form___row"}, [
                                eotwJSXFactory('input', {type: "hidden", name: "color", value: data['color']}),
                                eotwJSXFactory('span', {class: "form__error-message form__error-message--relative js-modal-error"}),
                                eotwJSXFactory('button', {type: "submit", class: "form__submit form__submit--paypal form__submit--disabled"}, [
                                    "Continue to",
                                    eotwJSXFactory('span', {class: "modal__paypal"}).html('<svg><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="' + window.CONFIG.urls.website + '/includes/svg-icons.svg#paypal-logo"/></svg>')
                                ])
                            ])
                        ])
                    ])
                ])
            ])
        );

        let formInvalid;

        validator = FormValidator.attach($bookingForm).on("input:invalid", function (data) {
            data.input.$input.parents('.form__row').addClass('form__row--modal-error');
        }).on("input:valid", function (data) {
            data.input.$input.parents('.form__row').removeClass('form__row--modal-error');
        }).on("invalid", function ($form) {
            if (!formInvalid) {
                formInvalid = true;
                return;
            }
            let $btn = $form.find("button[type='submit']");
            $btn.addClass("form__submit--loading");
            $form.find('.form__row--error').removeClass('form__row--error');
            setTimeout(() => {
                $.each(this.inputs, function (_, input) {
                    input.validate();
                });
                $btn.removeClass('form__submit--loading');
            }, 600);
        }).on("submit", function ($form) {
            $bookingForm.find('.js-modal-error').removeClass('form__error-message--shown');
            let $btn = $form.find('button[type=submit]');
            if ($btn.is('.form__submit--disabled')) {
                let text = '';
                if (tickets.adult.length + tickets.child.length > MAX_TICKETS) {
                    text = 'You can only order up to a maximum of 30 tickets online, if you require more tickets please give us a call';
                } else if (tickets.adult.length > 0 || tickets.child.length > 0) {
                    text = 'There are not enough spaces left to complete your booking';
                } else {
                    text = 'You must select at least one ticket';
                }
                $bookingForm.find('.js-ticket-error').text(text).addClass('form__error-message--shown');
                return;
            }
            if ($btn.is('.form__submit--loading')) return;
            $btn.addClass('form__submit--loading');
            $bookingForm.addClass('modal__booking-form--loading');
            Ajax.post('sk8house', 'events/' + window.eventData.id + '/booking', $bookingForm.serializeJSON(), Ajax.WEBSITE).then((data) => {
                window.location.href = data.next;
            }).catch((e) => {
                $bookingForm.find('.js-modal-error').text(e.message).addClass('form__error-message--shown');
                $btn.removeClass('form__submit--loading');
                $bookingForm.removeClass('modal__booking-form--loading');
            });
        });

        $bookingForm.on('click', '.js-back-modal', function () {
            LocationModal.create_modal_content(modal, data, validator);
            return false;
        }).on('click', '.js-numeric-button', function () {
            let amount = $(this).attr('data-direction') === '-' ? -1 : 1;
            let type = $(this).attr('data-type');
            $bookingForm.find('input[name="' + type + '"]').val(tickets[type].length + amount).change();
        }).on('keypress', '.js-ticket-amount', (evt) => {
            if (evt.which != 8 && evt.which != 0 && evt.which < 48 || evt.which > 57) {
                evt.preventDefault();
            }
        }).on('change', '.js-ticket-amount', function () {

            let amount = parseInt($(this).val());

            let type = $(this).attr('data-type');

            if (amount < 0) {
                amount = 0;
                $bookingForm.find('input[name="' + type + '"]').val(amount);
            }

            let additionalTickets = amount - tickets[type].length;

            if (additionalTickets < 0) {
                for (let i = 0; i > additionalTickets; i--) {
                    tickets[type].pop();
                }
            } else if (additionalTickets > 0) {
                for (let i = 0; i < additionalTickets; i++) {
                    tickets[type].push({size: null});
                }
            }

            let totalSpaces = tickets.adult.length + tickets.child.length;

            if (totalSpaces > MAX_TICKETS) {
                $bookingForm.find('.js-ticket-error').text('You can only order up to a maximum of 30 tickets online, if you require more tickets please give us a call').addClass('form__error-message--shown');
                $bookingForm.find('.form__submit').addClass('form__submit--disabled');
            } else if (totalSpaces > window.eventData.spacesRemaining) {
                $bookingForm.find('.js-ticket-error').text('There are not enough spaces left to complete your booking').addClass('form__error-message--shown');
                $bookingForm.find('.form__submit').addClass('form__submit--disabled');
            } else {
                $bookingForm.find('.js-ticket-error').text('').removeClass('form__error-message--shown');
                if (totalSpaces > 0) {
                    $bookingForm.find('.form__submit').removeClass('form__submit--disabled');
                }
            }

            if (additionalTickets !== 0 && totalSpaces <= MAX_TICKETS) {
                LocationModal.update_tickets($bookingForm, tickets);
            }
        });

        modal.setContent($bookingForm);
    }
}

export default LocationModal;
